module.exports = __webpack_public_path__ + "static/media/logo-baodautu.6a32c467.png";